import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

export const useResumeSubscription = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (subscriptionId: string) =>
      subscriptionService.resumeSubscription(subscriptionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organizationSubscription'] });
      toast.success(tActionMessages.subscriptionResumedSuccessfully);
    },
    onError: (error: any) => {
      toast.error(error?.response?.errors?.[0]?.message || tActionMessages.failedToResumeSubscription);
    },
  });
};
